import { render, staticRenderFns } from "./bandigoods.vue?vue&type=template&id=3f8ba33d&"
import script from "./bandigoods.vue?vue&type=script&lang=js&"
export * from "./bandigoods.vue?vue&type=script&lang=js&"
import style0 from "./bandigoods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports